import React from "react";
import { Card, CardBody } from "reactstrap";

/**
 * Página placeholder para módulos ainda não implementados.
 * Exibida enquanto o módulo está em desenvolvimento.
 */
const UnderDevelopment = ({ title, description }) => {
    return (
        <Card>
            <CardBody className="text-center py-5">
                <div className="mb-4">
                    <i
                        className="mdi mdi-tools"
                        style={{ fontSize: "3.5rem", color: "var(--bs-secondary)" }}
                    />
                </div>
                <h4 className="mb-2">{title || "Em desenvolvimento"}</h4>
                <p className="text-muted mb-0">
                    {description || "Este módulo está sendo desenvolvido e estará disponível em breve."}
                </p>
            </CardBody>
        </Card>
    );
};

export default UnderDevelopment;
